export const accountPlans=[
  {
    id:'solo',
    name:'Solo',
    price:'$19',
    brandLimit:1,
    postLimit:20,
    description:'For founders building one brand with intention.',
    features:[
      '1 brand',
      '20 posts per month',
      'Platform caption variants',
      'Review and approval workflow'
    ]
  },
  {
    id:'growing',
    name:'Growing',
    price:'$49',
    brandLimit:3,
    postLimit:75,
    description:'For entrepreneurs managing a few active brands.',
    features:[
      '3 brands',
      '75 posts per month',
      'Learnings log',
      'Priority creative drafts'
    ],
    recommended:true
  },
  {
    id:'agency',
    name:'Agency',
    price:'$99',
    brandLimit:10,
    postLimit:null,
    description:'For teams creating content across a portfolio.',
    features:[
      '10 brands',
      'Unlimited post drafts',
      'Shared brand workspaces',
      'Advanced review history'
    ]
  }
];

export function getAccountPlan(planId) {
  return accountPlans.find((plan)=> plan.id===planId) || accountPlans[1];
}